import { useEffect, useState } from "react";

import { Box, Card, Grid, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { useTranslation } from "react-i18next";

import MDBox from "@vendor/components/MDBox";
import { TableDetails } from "@modules/preinvoice";
import { MainLayout } from "@shared/ui/MainLayout";
import { useLoading } from "@shared/hooks/useLoading";
import { getInvoiceSubmissionById } from "../api/invoiceApi";

import type { InvoiceSubmission, Invoice } from "../api/invoiceApi";
import type { Schemas } from "@shared/api/types";

export const InvoiceDetailsPage = () => {
    const { t } = useTranslation();
    const { loading, thisLoading, notLoading } = useLoading()
    const [invoiceSubmissions, setInvoiceSubmissions] = useState<InvoiceSubmission>()
    const [invoice, setInvoice] = useState<Invoice>()
    const [detailsInvoice, setDetailsInvoice] = useState<Schemas["InvoiceDetailDTO"][] | undefined>([])
    const { invoiceSubmissionId } = useParams()

    useEffect(() => {
        thisLoading()
        // `invoiceSubmissionId` (route param) llega como string; la API espera un id numérico.
        getInvoiceSubmissionById(Number(invoiceSubmissionId)).then((data) => {
            console.log("dta", data)
            // Bug preexistente: `data.invoice` es opcional en el DTO (submissions manuales/planas
            // no lo traen); si viniera undefined, este acceso lanza `TypeError`. Se preserva tal
            // cual (mismo comportamiento que `InvoicePage`/`transformToDTO`, sin guard nuevo).
            setDetailsInvoice(data.invoice!.detailList)
            setInvoice(data.invoice)
            setInvoiceSubmissions(data)
            notLoading()
        }).catch()
    }, [])

    return (
        <MainLayout loading={loading}>
            <MDBox py={3}>
                <Card>
                    <MDBox p={2}>
                        <Grid container>
                            <Grid size={12}>
                                <Typography variant="h5">{t("invoice").toUpperCase()}</Typography>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <Box sx={{display: "flex", flexDirection: "row"}}>
                                    <Typography variant="h6">{t("name")}: </Typography>
                                    {/* Bug preexistente: "p" no es un `TypographyVariant` de MUI (no hay estilo
                                        para eso); en runtime esto ya caía al fallback `component="span"` sin clase
                                        de variante aplicada. Se preserva el valor tal cual con un cast, sin
                                        "corregirlo" a "body1" (cambiaría el estilo visual actual). */}
                                    <Typography variant={"p" as never} sx={{ fontSize: 15 }}>{invoice?.consultantName}</Typography>
                                </Box>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <Box sx={{display: "flex", flexDirection: "row"}}>
                                    <Typography variant="h6">{t("number")}: </Typography>
                                    <Typography variant={"p" as never} sx={{ fontSize: 15 }}>{invoiceSubmissions?.invoiceNumber}</Typography>
                                </Box>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <Box sx={{display: "flex", flexDirection: "row"}}>
                                    <Typography variant="h6"> {t("numberPassPort")}: </Typography>
                                    <Typography variant={"p" as never} sx={{ fontSize: 15 }}>{invoice?.consultantPassportNumber}</Typography>
                                </Box>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <Box sx={{display: "flex", flexDirection: "row"}}>
                                    <Typography variant="h6"> {t("city")}: </Typography>
                                    <Typography variant={"p" as never} sx={{ fontSize: 15 }}>{invoice?.consultantCity}</Typography>
                                </Box>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <Box sx={{display: "flex", flexDirection: "row"}}>
                                    <Typography variant="h6">{t("creationDate")}: </Typography>
                                    <Typography variant={"p" as never} sx={{ fontSize: 15 }}>{invoice?.sent === undefined ? '' : format(parseISO(invoice.sent), 'dd/MM/yyyy')}</Typography>
                                </Box>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <Box sx={{display: "flex", flexDirection: "row"}}>
                                    <Typography variant="h6"> {t("country")}: </Typography>
                                    <Typography variant={"p" as never} sx={{ fontSize: 15 }}>{invoice?.consultantCountry}</Typography>
                                </Box>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <Box sx={{display: "flex", flexDirection: "row"}}>
                                    <Typography variant="h6"> {t("period")}: </Typography>
                                    <Typography variant={"p" as never} sx={{ fontSize: 15 }}>{invoiceSubmissions?.invoiceDate === undefined ? '' : format(parseISO(invoiceSubmissions.invoiceDate), 'dd/MM/yyyy')}</Typography>
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <TableDetails details={detailsInvoice} t={t}/>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>
            </MDBox >
        </MainLayout >
    );
}
